//import logo from './logo.svg';
import './App.css';
import Display from './sprint-1/day-1/assignments/Display ';
import List from './sprint-1/day-1/assignments/List';
import Counter from "./sprint-1/day-2/assignments/Counter";
import TODO from './sprint-1/day-2/assignments/TODO';
import Button from './sprint-1/day-2/we/Buttons';
import EmployeeDetails from './sprint-1/day-2/we/EmployeeDetails';
import Hedd from './sprint-1/day-2/we/Hedd';
import Input from './sprint-1/day-2/we/Input';
import { Todo } from './sprint-1/day-2/we/Todo';
import State from './sprint-1/day-2/we/UsState';
// import PaymentCard from './sprint-1/day-3/assignments/PaymentCard';
import Rendering from './sprint-1/day-3/we/Rendering';
import TodoList from './sprint-1/day-3/we/TodoList';
import { TodoMain } from './sprint-1/day-3/we/TodoMain';
import TicTacToe from './sprint-1/day-4/assignments/TicTacTow';
import ShowHide from './sprint-2/day-2/we/ShowHide';
import Final from './sprint-2/day-3/we/Final';
import  Form  from './sprint-2/day-4/assignments/Form/Form';
import GoogleTimer from './sprint-2/day-4/assignments/GoogleTimer/GoogleTimer';
import RestaurantDetails from './sprint-2/day-4/assignments/RestaurantDetails/RestaurantDetails';
import { TimerShow } from './sprint-2/day-4/assignments/TimerShow';
import Mui from './sprint-3/day-1/we/MUI-Liberry/Mui';
import Styl from './sprint-3/day-1/we/Styl';
import CreditCardForm from './sprint-3/day-2/assignments/CreaditCard/CreditCardForm';
import MainPage from './sprint-3/day-2/we/PageComponents/MainPage';
import MainApp from './sprint-3/day-2/you/MainApp';
import Figma from './sprint-3/day-3/assignments/ContestFigmaAssignment/Figma';
import MealApp from './sprint-3/day-4/assignments/RoutingAssignment/MealApp';
import DynamicRouting from './sprint-3/day-4/we/DynamicRouting/DynamicRouting';
import Routing from './sprint-3/day-4/we/ReactRouterDom/Routing';
import RoutingTwoApp from './sprint-3/optional/ReactRoutingTwo/RoutingTwoApp';
import ReduxFirstApp from './sprint-4/day-2/we/ReduxWithReact/ReduxFirstApp';
import AssignmentRedux from './sprint-4/evaluation/CombineReducers/AssignmentRedux';
import MedalwereCounter from './sprint-4/evaluation/ReactMedalwere/Components/MedalwereCounter';
import ReduxThunk from './sprint-4/evaluation/ReduxThunk/ReduxThunk';
import ReduxCT from './sprint-4/optional/ReduxCT';



function App() {
  return (
  <div className='App'>
   {/* <List/>
   <Display/> */}
   {/* <h1 className='header'>Student Form</h1> */}
   {/* <Input/>
   <Button/>
   <Hedd/> */}
   {/* <EmployeeDetails/> */}
  {/* <State/> */}
  {/* <Counter/> */}
  {/* <Rendering/> */}
  {/* <TodoList/> */}
  {/* <PaymentCard/> */}
  {/* <TODO/> */}
  {/* <ShowHide/> */}
  {/* <Final/> */}
  {/* <TimerShow/> */}
  {/* <Form/> */}
  {/* <TicTacToe/> */}
  {/* <GoogleTimer/> */}
  {/* <RestaurantDetails/> */}
  {/* <Styl/> */}
  {/* <Mui/> */}
  {/* <Buttons/> */}
  {/* <MainPage/> */}
  {/* <MainApp/> */}
  {/* <Routing/> */}
  {/* <DynamicRouting/> */}
  <MealApp/>
{/* <CreditCardForm/>   */}
{/* <RoutingTwoApp/> */}
{/* <ReduxApp/> */}
{/* <ReduxFirstApp/> */}
{/* <Figma/> */}
{/* <ReduxCT/> */}
{/* <AssignmentRedux/> */}
{/* <MedalwereCounter/> */}
{/* <ReduxThunk/> */}
  </div>
  );
}
export default App;
